module.exports = __webpack_public_path__ + "static/img/jiadian-thumb.ab86c1c3.png";